import { useLocalization } from '@faceup/localization'
import { getSupportUrlByLanguage as getSupportUrlByLanguageUtil, Language } from '@faceup/utils'
import { useCallback } from 'react'

const useConfigForProject = () => {
  const { language } = useLocalization()
  const getSupportUrlByLanguage = useCallback((language: Language) => {
    return getSupportUrlByLanguageUtil(language)
  }, [])

  const isSk = language === Language.Sk

  return { getSupportUrlByLanguage, isSk }
}

export default useConfigForProject
